import { IconDownload } from '@tabler/icons';
import { ConfigProvider, Modal, Pagination, Row, Col, Table, Dropdown, Menu, Space, Typography } from 'antd';
import classNames from 'classnames/bind';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { FacebookIcon, FacebookShareButton } from 'react-share';
import styled from 'styled-components';
import packAPI from '~/api/PackAPI';
import { IMAGES, SVGS } from '~/assets/assetsPath';
import EmptyForm from '~/components/Empty';
import CancelModal from '~/components/FormCancel';
import { getNumberWithCommas } from '~/utils';
import CardAboutMe from '../../components/card-about-me';
import styles from './MyCard.module.scss';
import SplitCard from '~/components/SplitCard';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import offerAPI from '~/api/OfferAPI';
import { useNavigate } from 'react-router';
import config from '~/config';
import { DownOutlined } from '@ant-design/icons';

const cx = classNames.bind(styles);
const PaginationCustom = styled.div`
    .ant-pagination-options {
        display: none;
    }
`;

const MyCard = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const userInfo = useSelector((state) => state.user.userInfo);
    const [myCards, setMyCards] = useState([]);

    const [isShowQRCode, setIsShowQRCode] = useState(false);
    const [qrCodeZoom, setQRCodeZoom] = useState('');
    const [isShowShare, setIsShowShare] = useState(false);

    const [isShowAsk, setIsShowAsk] = useState(false);
    const [checkedStatus, setCheckedStatus] = useState(false);
    const [idUpdate, setIdUpdate] = useState('');
    const [textNoti, setTextNoti] = useState('');
    const [isCard, setIsCard] = useState(true);
    const [isUsedCard, setIsUsedCard] = useState(false);
    const [filterOrder, setFilterOrder] = useState({ title: 'All', value: undefined });

    const [isShowSplitCard, setIsShowSplitCard] = useState(false);

    const [listOffer, setListOffer] = useState([]);

    const onAgreeAsk = async () => {
        try {
            await packAPI.updateStatusConfirm(idUpdate, {
                is_confirm: checkedStatus,
            });
            handleGetMyCard(pagination.page);
        } catch (error) {}
        setIsShowAsk(false);
    };
    const onCancelAsk = () => {
        setIsShowAsk(false);
    };

    // const onChangeSwitchStatus = (checked, id) => {
    //     setIsShowAsk(true);
    // setTextNoti(checked ? 'Are you sure you have received the money' : 'Are you sure you have not received the money');
    //     setIdUpdate(id);
    //     setCheckedStatus(checked);
    // };

    const renderExpireDay = (item) => {
        switch (item?.time_type) {
            case 'DAY':
                return `${item?.expired} date`;
            case 'MONTH':
                return `${item?.expired} month`;
            case 'YEAR':
                return `${item?.expired} year`;
            default:
                return;
        }
    };

    const columns = [
        {
            title: () => {
                return <div className={cx('title_header')}>STT</div>;
            },

            render: (text, record, index) => <div>{(pagination.page - 1) * 10 + index + 1}</div>,
            align: 'center',
        },
        {
            title: () => {
                return <div className={cx('title_header')}>QR Code</div>;
            },
            render: (text, record, index) => (
                <img
                    src={record.qr_code_link}
                    alt=""
                    style={{ width: '60px', cursor: 'pointer' }}
                    onClick={() => {
                        setQRCodeZoom(record.qr_code_link);
                        setIsShowQRCode(true);
                    }}
                />
            ),
            align: 'center',
        },
        {
            title: () => {
                return <div className={cx('title_header')}>Value</div>;
            },
            render: (text, record, index) => <div>{getNumberWithCommas(record.value)} d</div>,
            align: 'center',
        },
        // {
        //     title: () => {
        // return <div className={cx('title_header')}>Offers</div>;
        //     },
        //     render: (text, record, index) => <div>{record.endow}%</div>,
        //     align: 'center',
        // },
        {
            title: () => {
                return <div className={cx('title_header')}>Receive</div>;
            },
            render: (text, record, index) => <div>{getNumberWithCommas((record.endow * record.value) / 100)} d</div>,
            align: 'center',
        },
        {
            title: () => {
                return <div className={cx('title_header')}>Expiry date</div>;
            },
            render: (text, record, index) => <div>{renderExpireDay(record)}</div>,
            align: 'center',
        },
        // {
        //     title: () => {
        // return <div className={cx('title_header')}>Confirm payment</div>;
        //     },
        //     render: (text, record, index) => (
        //         <div>
        //             <Switch
        //                 checked={record.is_confirm}
        //                 onChange={(value) => onChangeSwitchStatus(value, record.id)}
        //                 disabled={!record.is_used}
        //             />
        //         </div>
        //     ),
        //     align: 'center',
        // },
        {
            title: () => {
                return <div className={cx('title_header')}>Status</div>;
            },
            render: (text, record, index) => <div>{record.is_used ? 'Used' : 'Unused'}</div>,
            align: 'center',
        },
        {
            title: () => {
                return <div className={cx('title_header')}>Function</div>;
            },
            render: (text, record, index) => (
                <div
                    className={cx('shareBtn')}
                    onClick={() => {
                        setQRCodeZoom(record.qr_code_link);
                        setIsShowShare(true);
                    }}
                >
                    Share
                </div>
            ),
            align: 'center',
        },
    ];

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total_item: 0,
        total_page: 0,
    });

    const handleGetMyCard = async (page, sort) => {
        try {
            setIsLoading(true);
            let cards = [];
            const filterS = {
                owner_id: userInfo?.id ? userInfo?.id : undefined,
                is_used: sort ? sort?.value : undefined,
                // deducted_price: {
                //     $between: [range[0] * 1000, range[1] * 1000],
                // },
            };
            const params = {
                fields: '["$all"]',
                // filter: `{"owner_id" : "${userInfo?.id}"}`,
                filter: JSON.stringify(filterS),
                order: '[["created_at", "DESC"]]',
                limit: pagination.limit,
                page: page,
            };
            const res = await packAPI.getListPackAPI(params);

            if (res.code === 200) {
                cards = res.results.objects.rows;
                for (let i = 0; i < cards.length; i++) {
                    let temp = listOffer.filter((x) => parseInt(x.from) === cards[i].value);
                    if (temp.length) {
                        cards[i].expired = temp[0].expired;
                        cards[i].time_type = temp[0].time_type;
                    }
                }
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.objects.count,
                    total_page: Math.ceil(res.results.objects.count / pagination.limit),
                });
            }
            setMyCards(cards);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
        }
    };
    const handleChangePage = (page) => {
        setPagination({ ...pagination, page });
        handleGetMyCard(page, filterOrder);
        window.scrollTo(0, 0);
    };

    const handleSaveQRCode = (image) => {
        saveAs(image, `qr-code-booking-${moment().valueOf()}.png`);
    };

    useEffect(() => {
        handleGetListOffer();
        //eslint-disable-next-line
    }, []);
    useEffect(() => {
        handleGetMyCard(pagination.page, filterOrder);

        //eslint-disable-next-line
    }, [listOffer]);

    const handleGetListOffer = async () => {
        try {
            const params = {
                fields: '["$all"]',
                order: '[["from", "asc"]]',
                limit: 999,
                page: 1,
            };
            const res = await offerAPI.getListOfferAPI(params);
            if (res.code === 200) {
                setListOffer([...res.results.objects.rows]);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const mountRef = useRef(true);
    useEffect(() => {
        if (mountRef.current) {
            mountRef.current = false;
            return;
        }
        const script = document.createElement('script');

        script.src = 'https://sp.zalo.me/plugins/sdk.js';

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [isShowShare]);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangTheCuaToi');
        // eslint-disable-next-line
    }, []);

    const handleSelectFilterOrder = (item) => {
        setFilterOrder(item);
        handleGetMyCard(pagination.page, item);
    };
    const menuSort = (
        <Menu
            items={[
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'All',
                                    value: undefined,
                                })
                            }
                        >
                            All
                        </p>
                    ),
                    key: '1',
                },
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'Unused',
                                    value: false,
                                })
                            }
                        >
                            Not yet used
                        </p>
                    ),
                    key: '2',
                },
                {
                    label: (
                        <p
                            onClick={() =>
                                handleSelectFilterOrder({
                                    title: 'Used',
                                    value: true,
                                })
                            }
                        >
                            Used
                        </p>
                    ),
                    key: '3',
                },
            ]}
        />
    );
    console.log('myCard', myCards);
    return (
        <>
            {/* PC UI */}
            <div className={cx('wrapper')}>
                <div className={cx('container')}>
                    <div className={cx('left_section')}>
                        <div className={cx('left_wrapper')}>
                            <div className={cx('left_container')}>
                                <Row>
                                    <CardAboutMe tabIndex={{ parent: 2, children: 0 }} />
                                </Row>
                            </div>
                        </div>
                    </div>
                    <div className={cx('right_section')}>
                        <Row className={cx('name_page')} align="middle">
                            <Col xs={20}>My Tags</Col>
                            <Col xs={4}>
                                <Row justify="end">
                                    <img src={SVGS.IconPlusCircle} alt="" onClick={() => setIsShowSplitCard(true)} />
                                </Row>
                            </Col>
                        </Row>
                        <div className={cx('right_container')}>
                            {/* <div className={cx('table_container')}> */}
                            <Row>
                                <ConfigProvider renderEmpty={() => <EmptyForm />}>
                                    <Table
                                        className={cx('table')}
                                        columns={columns}
                                        dataSource={myCards}
                                        pagination={false}
                                        loading={isLoading}
                                    />
                                </ConfigProvider>
                            </Row>
                            {myCards?.length ? (
                                <Row justify="center" style={{ marginTop: '30px' }}>
                                    <PaginationCustom>
                                        <Pagination
                                            defaultCurrent={1}
                                            current={pagination?.page}
                                            total={pagination?.total_item}
                                            pageSize={pagination?.limit}
                                            onChange={handleChangePage}
                                        />
                                    </PaginationCustom>
                                </Row>
                            ) : null}
                            {/* </div> */}
                        </div>
                    </div>
                </div>
                {isShowQRCode && (
                    <Modal
                        centered
                        title="QR Code"
                        visible={isShowQRCode}
                        onCancel={() => setIsShowQRCode(false)}
                        maskClosable={false}
                        footer={null}
                        width={500}
                        // className="otp-modal"
                    >
                        <div style={{ padding: '10px 10px' }}>
                            <img src={qrCodeZoom || IMAGES.ImagePlaceholder} alt="" className={cx('qr_code_zoom')} />
                        </div>
                    </Modal>
                )}
                {isShowShare && (
                    <Modal
                        centered
                        title="Share"
                        visible={isShowShare}
                        onCancel={() => setIsShowShare(false)}
                        maskClosable={false}
                        footer={null}
                        width={500}
                        // className="otp-modal"
                    >
                        <Row style={{ padding: '10px 10px' }}>
                            <img src={qrCodeZoom || IMAGES.ImagePlaceholder} alt="" className={cx('qr_code_zoom')} />
                        </Row>
                        <Row justify="center" align="middle">
                            <div
                                className="zalo-share-button"
                                data-href={qrCodeZoom}
                                data-oaid="579745863508352884"
                                data-layout="4"
                                data-color="blue"
                                data-share-type="2"
                                data-customize="true"
                            >
                                <div className={cx('share_zalo')}>
                                    <img src="https://stc.sp.zdn.vn/share/logo_white_s_2x_40.png" alt="zaloImg" />
                                </div>
                            </div>

                            <FacebookShareButton url={qrCodeZoom}>
                                <FacebookIcon size={52} className={cx('share_facebook')} />
                            </FacebookShareButton>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    color: 'black',
                                }}
                                onClick={() => handleSaveQRCode(qrCodeZoom)}
                            >
                                <IconDownload size={50} />
                            </div>
                        </Row>
                    </Modal>
                )}
                {isShowAsk && (
                    <Modal
                        centered
                        visible={isShowAsk}
                        onCancel={() => setIsShowAsk(false)}
                        maskClosable={false}
                        footer={null}
                        className="otp-modal"
                        width={500}
                    >
                        <div style={{ padding: '20px 20px' }}>
                            <CancelModal onAgreeCancel={onAgreeAsk} onRejectCancel={onCancelAsk} text={textNoti} />
                        </div>
                    </Modal>
                )}
                {isShowSplitCard && (
                    <Modal
                        centered
                        visible={isShowSplitCard}
                        onCancel={() => setIsShowSplitCard(false)}
                        maskClosable={false}
                        footer={null}
                        className="otp-modal"
                        width={700}
                    >
                        <div style={{ padding: '20px 20px' }}>
                            <SplitCard
                                wallet={userInfo?.wallet}
                                userId={userInfo?.id}
                                setIsShowSplitCard={setIsShowSplitCard}
                                handleGetMyCard={handleGetMyCard}
                            />
                        </div>
                    </Modal>
                )}
            </div>

            {/* MB UI */}
            <div className={cx('wrapper_mb')}>
                <div className={cx('title_header')}>
                    <Row className={cx('header_row')}>
                        <Col>
                            <Row>
                                <img
                                    src={SVGS.ImageChevronLeft}
                                    alt="icon chevron left"
                                    className={cx('btn_search')}
                                    onClick={() => navigate(config.routes.personalPage)}
                                />
                                <span className={cx('header_title')}>My tags</span>
                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <img
                                    src={SVGS.IconPlusCircle}
                                    alt=""
                                    className={cx('btn_search')}
                                    onClick={() => setIsShowSplitCard(true)}
                                />

                                <Dropdown overlay={menuSort} trigger={['click']}>
                                    <button onClick={(e) => e.preventDefault()} className={cx('button')}>
                                        <img src={SVGS.IconSortDescending} alt="icon card" />
                                    </button>
                                </Dropdown>
                            </Row>
                        </Col>
                    </Row>
                    <Row className={cx('header_row')}>
                        <Col>
                            <Row>
                                <span
                                    className={isCard ? cx('header_title_card_active') : cx('header_title_card')}
                                    onClick={() => {
                                        setIsCard(true);
                                        setIsUsedCard(false);
                                    }}
                                >
                                    My cards
                                </span>
                            </Row>
                        </Col>
                        <Col>
                            <Row>
                                <span
                                    className={isUsedCard ? cx('header_title_card_active') : cx('header_title_card')}
                                    onClick={() => {
                                        setIsCard(false);
                                        navigate(config.routes.useCard);
                                        setIsUsedCard(true);
                                    }}
                                >
                                    Card user
                                </span>
                            </Row>
                        </Col>
                    </Row>
                </div>
                {isCard && (
                    <div className={cx('container_card')}>
                        {myCards?.length > 0 ? (
                            myCards.map((item, index) => {
                                return (
                                    <Row key={index} className={cx('item_my_card')}>
                                        <Col xs={8}>
                                            <img src={item?.qr_code_link} alt="" style={{ width: '100%' }} />
                                        </Col>
                                        <Col>
                                            <Row>
                                                <Col style={{ marginRight: '5px' }}>Value:</Col>
                                                <Col>{getNumberWithCommas(item.value)} d</Col>
                                            </Row>
                                            <Row>
                                                <Col style={{ marginRight: '5px' }}>Expiry date:</Col>
                                                <Col>{renderExpireDay(item)}</Col>
                                            </Row>
                                            {item?.is_used && (
                                                <Row>
                                                    <div className={cx('item_my_card_status')}>Used</div>
                                                </Row>
                                            )}
                                            {/* <Row>
                                                <div className={cx('item_my_card_status')}>
                                                    {item?.is_used ? 'Used' : 'Unused'}
                                                </div>
                                            </Row> */}
                                        </Col>
                                        <Col>
                                            <img
                                                src={SVGS.IconShare}
                                                alt=""
                                                className={cx('btn_search')}
                                                onClick={() => {
                                                    setQRCodeZoom(item?.qr_code_link);
                                                    setIsShowShare(true);
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                );
                            })
                        ) : (
                            <div className={cx('no_service')}>
                                <img src={SVGS.IconNoService} alt="" />
                                <span>No data!</span>
                            </div>
                        )}

                        {myCards?.length ? (
                            <Row justify="center" style={{ margin: '30px 0px' }}>
                                <PaginationCustom>
                                    <Pagination
                                        defaultCurrent={1}
                                        current={pagination?.page}
                                        total={pagination?.total_item}
                                        pageSize={pagination?.limit}
                                        onChange={handleChangePage}
                                    />
                                </PaginationCustom>
                            </Row>
                        ) : null}
                    </div>
                )}
            </div>
        </>
    );
};

export default MyCard;
